export const getAlternativeProductDetails = (mailcode, productArray) => {
    const alternativeProduct = productArray.filter(product => product.mailcode === mailcode);
    return alternativeProduct.length > 0 ? alternativeProduct[0]?.productData : null;
};

export const getAlternativeProductUrl = async (mailcode, productArray, partnerUrl) => {
    if (typeof (window) !== 'undefined') {
        const url = new URL(window.location);
        const property = url.searchParams.get('propertyType');
        const alternativeProduct = productArray.filter(product => product.mailcode === mailcode);
        return alternativeProduct.length > 0 ? `${partnerUrl}/${alternativeProduct[0]?.productData.name.replace(/\W+/g, '-').toLowerCase()}${property !== null ? `/?propertyType=${property}` : '/'} ` : '#';
    }
};

export const updateBodyClass = (propertyType) => {
    document.body.classList.remove('house');
    document.body.classList.remove('flat');
    document.body.classList.remove('both');
    document.body.classList.add(propertyType.toLowerCase());
    return true;
};
